import Header from "./Header";
import Footer from "./Footer";
import { useDirection } from "../../hooks/useDirection";
import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const direction = useDirection();
  const location = useLocation();

  // لو الراوت يحتوي على /admin → نخفي Header وFooter
  const hideLayout = location.pathname.startsWith("/admin");

  return (
    <div
      className="min-h-screen bg-gradient-to-b from-blue-50 to-white dark:from-gray-950 dark:to-gray-900"
      dir={direction}
    >
      {/* Skip to content link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 py-2 rounded-lg z-50"
      >
        Skip to main content
      </a>

      {/* Header */}
      {!hideLayout && <Header />}

      {/* Main content */}
      <main id="main-content" className="flex-1">
        {children}
      </main>

      {/* Footer */}
      {!hideLayout && <Footer />}
    </div>
  );
};

export default Layout;
